import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const GlobalReach = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const countries = [
    {
      name: t.home.countries.czechRepublic,
      city: 'Prague',
      image: 'https://images.unsplash.com/photo-1519677100203-a0e668c92439?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxQcmFndWV8ZW58MHx8fHwxNzYyMTc3MTA4fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      name: t.home.countries.germany,
      city: 'Frankfurt',
      image: 'https://images.unsplash.com/photo-1607879344639-d5f8dec22a60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxGcmFua2Z1cnQlMjBza3lsaW5lfGVufDB8fHx8MTc2MjE3NzExM3ww&ixlib=rb-4.1.0&q=85'
    },
    {
      name: t.home.countries.uk,
      city: 'London',
      image: 'https://images.unsplash.com/photo-1745016176874-cd3ed3f5bfc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxMb25kb24lMjBCaWclMjBCZW58ZW58MHx8fHwxNzYyMTc3MTE5fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      name: t.home.countries.turkey,
      city: 'Istanbul',
      image: 'https://images.unsplash.com/photo-1589561454226-796a8aa89b05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxJc3RhbmJ1bCUyMEJvc3Bob3J1c3xlbnwwfHx8fDE3NjIxNzcxMjN8MA&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <section className="py-20 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            {t.home.countries.subtitle}
          </h2>
        </motion.div>

        {/* Country Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {countries.map((country, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative h-80 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              {/* Country Image */}
              <img
                src={country.image}
                alt={country.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              
              {/* Country Name */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-2xl font-bold text-white mb-1">
                  {country.name}
                </h3>
                <p className="text-white/80 text-sm">
                  {country.city}
                </p>
              </div>
              
              {/* Hover Accent */}
              <div className="absolute top-0 left-0 w-1 h-0 bg-[#ff5200] group-hover:h-full transition-all duration-500"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GlobalReach;
